<template>
    <div class="fixed-footer elevation-8 white">
        <v-row no-gutters align="center">
            <v-col cols="auto">
                <div class="qty-pill">
                    <v-btn icon small :disabled="cantidad <= 1 || disabledProduct" @click="$emit('decrease')">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <span class="qty-value">{{ cantidad }}</span>
                    <v-btn icon small :disabled="disabledProduct" @click="$emit('increase')">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col class="pl-3">
                <v-btn
                    rounded
                    block
                    large
                    :color="agotado ? 'error' : 'primary'"
                    class="add-btn"
                    :disabled="disabledProduct"
                    @click="$emit('add-product')"
                >
                    {{ agotado ? 'Agotado' : `Agregar $${precioFormateado}` }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
  name: 'ProductFooter',
  props: {
    disabledProduct: {
      type: Boolean,
      default: true
    },
    agotado: {
      type: Boolean,
      default: false
    },
    cantidad: {
      type: Number,
      default: 1
    },
    precioTotal: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    precioFormateado () {
      const n = Number(this.precioTotal) || 0
      return n.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    }
  }
}
</script>
<style scoped>
.fixed-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.75rem 1rem;
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
    z-index: 100;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}
.qty-pill {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.18);
    border-radius: 999px;
    padding: 2px 4px;
    min-width: 110px;
    justify-content: space-between;
}
.qty-value {
    font-weight: 700;
    min-width: 24px;
    text-align: center;
}
.add-btn {
    font-weight: 700 !important;
    letter-spacing: 0.02em;
    text-transform: none !important;
}
</style>
